"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@angular/material");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var document_search_service_1 = require("../service/document-search-service");
var category_relation_config_1 = require("../model/config/category-relation-config");
var search_filters_1 = require("../model/api/search-filters");
var paging_config_1 = require("../model/config/paging-config");
var sub_entity_filter_1 = require("../model/api/sub-entity-filter");
var document_search_helper_1 = require("../util/document-search-helper");
var static_method_1 = require("../../../../../shared/utils/static-method");
var dialog_config_helper_1 = require("../../../../../shared/utils/dialog-config-helper");
var external_function_executor_service_1 = require("../service/external-function-executor-service");
var warning_dialog_component_1 = require("../../../../../shared/dialogs/warning/warning-dialog.component");
var document_operations_service_1 = require("../../../../../shared/services/api/document-operations.service");
var DocumentsSearchComponent = /** @class */ (function () {
    function DocumentsSearchComponent(documentSearchService, documentOperationsService, kbService, classifierService, localeService, currentLanguageProvider, applicationPropertiesService, http, portfolioService, dialog, externalFunctionExecutorService) {
        this.documentSearchService = documentSearchService;
        this.documentOperationsService = documentOperationsService;
        this.kbService = kbService;
        this.classifierService = classifierService;
        this.localeService = localeService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.applicationPropertiesService = applicationPropertiesService;
        this.http = http;
        this.portfolioService = portfolioService;
        this.dialog = dialog;
        this.externalFunctionExecutorService = externalFunctionExecutorService;
        this.minQuerySymbols = 4;
        this.searchDocumentsCount = 100;
        this.entityClick = new core_1.EventEmitter();
        this._isDescendingSort = false;
        this._additionalFilters = new Map();
        this._sunEntityFilter = new sub_entity_filter_1.SubEntityFilter();
        this._additionalDocumentMetaDataFilters = new Map();
        this._mainEntitiesDocuments = [];
        this._itemsCount = 0;
        this._startIndex = 0;
        this._requestsLimit = 0;
        this._isLoadedPartial = false;
        this._destroy$ = new Subject_1.Subject();
    }
    DocumentsSearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        var categories$ = this.kbService.getMainEntityMetaCategories();
        var searchableCategoryInstanceIdField$ = this.kbService.getInstanceMetaField(this.categoryRelationConfig.mainCategory);
        var users$ = this.classifierService.loadClassifiersView('User');
        var localeInfo$ = this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.switchMap(function (language) {
            _this._languageId = language.getId();
            return Observable_1.Observable.fromPromise(_this.localeService.getLocaleInfo(language.getId()));
        }));
        Observable_1.Observable.zip(categories$, users$, localeInfo$, searchableCategoryInstanceIdField$)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (data) {
            var categories = data[0];
            _this._users = document_search_helper_1.DocumentSearchHelper.constructUsersMap(data[1]);
            _this._categoryNameMetaFields = document_search_helper_1.DocumentSearchHelper.constructCategoryNameMetaFields(categories);
            _this._categoryDisplayName = document_search_helper_1.DocumentSearchHelper.constructCategoryDisplayName(categories);
            _this._additionalFilters = document_search_helper_1.DocumentSearchHelper.constructAdditionalFiltersMap(_this.additionalFilterConfigs);
            _this._additionalDocumentMetaDataFilters = document_search_helper_1.DocumentSearchHelper.constructAdditionalDocumentMetaDataFiltersMap(_this.additionalDocumentMetaDataFilterConfigs);
            _this._localeInfo = data[2];
            _this._mainCategoryInstanceFiledName = data[3].getSystemName();
            _this._isReady = true;
        });
    };
    DocumentsSearchComponent.prototype.onAdditionalFilterChange = function (category, filterCriteria) {
        this._additionalFilters.get(category).userDefined = filterCriteria;
        this._additionalFiltersExistsFlag = Array.from(this._additionalFilters.values()).some(function (filter) { return (filter && !!filter.userDefined); });
        this.resetFilterOptions();
    };
    DocumentsSearchComponent.prototype.onAdditionalDocumentMetaDataFilterChange = function (key, filterCriteria) {
        var _this = this;
        this._additionalDocumentMetaDataFilters.get(key).userDefined = filterCriteria;
        this._additionalDocumentMetaDataFiltersExistsFlag = false;
        this._additionalDocumentMetaDataFilters.forEach(function (filter, configKey) {
            var config = _this.additionalDocumentMetaDataFilterConfigs.find(function (value) { return value.key === configKey; });
            if (!config || !config.showInMain) {
                _this._additionalDocumentMetaDataFiltersExistsFlag = _this._additionalDocumentMetaDataFiltersExistsFlag || (filter && !!filter.userDefined);
            }
        });
        this.resetFilterOptions();
    };
    DocumentsSearchComponent.prototype.onSubEntityFilterChange = function (filter) {
        this._sunEntityFilter = filter;
        this.resetFilterOptions();
    };
    DocumentsSearchComponent.prototype.onEntityView = function (category, entity) {
        this.entityClick.emit({ category: category, entity: entity });
    };
    DocumentsSearchComponent.prototype.onDownload = function (doc, category, entity) {
        var _this = this;
        document_search_helper_1.DocumentSearchHelper.getInstanceFieldName(this.kbService, category)
            .pipe(operators_1.switchMap((function (instanceFieldName) {
            return _this.documentOperationsService.downloadDocument(+doc.documentId, category, entity[instanceFieldName], doc.fieldName);
        })), operators_1.takeUntil(this._destroy$))
            .subscribe();
    };
    DocumentsSearchComponent.prototype.onPreview = function (doc, category, entity) {
        var _this = this;
        document_search_helper_1.DocumentSearchHelper.getInstanceFieldName(this.kbService, category)
            .pipe(operators_1.switchMap((function (instanceField) { return _this.documentOperationsService.previewDocument(+doc.documentId, category, entity[instanceField], doc.fieldName); })), operators_1.takeUntil(this._destroy$))
            .subscribe();
    };
    DocumentsSearchComponent.prototype.changeSortStrategy = function () {
        this._isDescendingSort = !this._isDescendingSort;
    };
    DocumentsSearchComponent.prototype.onSearch = function () {
        this._expanded = false;
        this._searchTextErrorFlag = false;
        this._dateRangeErrorFlag = false;
        this._mainEntitiesDocuments = [];
        this._startIndex = 0;
        this._itemsCount = 0;
        this._requestsLimit = 0;
        // validate search query term, it is required and must be more then three symbols
        if (static_method_1.invalidTextLength(this.searchText, this.minQuerySymbols)) {
            this._searchTextErrorFlag = true;
            return;
        }
        // validate selected dates range, from date can not be greater than to date
        if (this._toDate && this._fromDate && this._fromDate > this._toDate) {
            this._dateRangeErrorFlag = true;
            return;
        }
        this.loadMoreDocuments();
    };
    DocumentsSearchComponent.prototype.loadMoreDocuments = function () {
        if (!this._searching) {
            this._searching = true;
            this._startIndex = this._startIndex + this._itemsCount;
            this._itemsCount = this.searchDocumentsCount;
            this.getMainEntitiesByFilters()
                .pipe(operators_1.switchMap(this.searchDocumentsByFilters.bind(this)), operators_1.catchError(document_search_helper_1.DocumentSearchHelper.handleDocumentSearchErrorResponse), operators_1.switchMap(this.processDocumentSearchResponse.bind(this)), operators_1.takeUntil(this._destroy$)).subscribe(this.afterSearchProcessing.bind(this));
        }
    };
    DocumentsSearchComponent.prototype.searchDocumentsByFilters = function (data) {
        if (data.filtered && data.entities.length === 0) {
            // the main category is filtered and no items are available by that filter
            return document_search_helper_1.DocumentSearchHelper.handleDocumentSearchErrorResponse();
        }
        var _a = this.getFilters(data.entities), filters = _a.filters, documentsFilter = _a.documentsFilter;
        var sortConfig = document_search_helper_1.DocumentSearchHelper.getDocumentSortConfig(this._isDescendingSort, this.sortDocumentFields);
        return this.documentSearchService.searchDocuments(this.searchText, new search_filters_1.SearchFilters(filters, documentsFilter, this._sunEntityFilter), new paging_config_1.PagingConfig(this._startIndex, this._itemsCount), true, true, sortConfig, this.excludedCategories)
            .pipe(operators_1.map(function (entitiesDocuments) {
            return { entities: data.entities, entitiesDocuments: entitiesDocuments };
        }));
    };
    DocumentsSearchComponent.prototype.processDocumentSearchResponse = function (data) {
        var _this = this;
        var entitiesDocumentsItems = data.entitiesDocuments.documents;
        var alreadyLoadedMainEntityIds = entitiesDocumentsItems
            .filter(function (value) { return value.category === _this.categoryRelationConfig.mainCategory; })
            .map(function (value) { return value.entity[_this._mainCategoryInstanceFiledName]; });
        var mainCategoryIdsToBeLoaded = entitiesDocumentsItems
            .filter(function (value) {
            return (value.category !== _this.categoryRelationConfig.mainCategory &&
                _this.categoryRelationConfig.lookupFields.has(value.category) &&
                alreadyLoadedMainEntityIds.indexOf(value.entity[_this.categoryRelationConfig.lookupFields.get(value.category)]) === -1);
        })
            .map(function (value) { return value.entity[_this.categoryRelationConfig.lookupFields.get(value.category)]; });
        return document_search_helper_1.DocumentSearchHelper.getMainEntitiesByInstanceIds(this.portfolioService, this._mainCategoryInstanceFiledName, mainCategoryIdsToBeLoaded, this.categoryRelationConfig.mainCategory).pipe(operators_1.map(function (loadedMainEntities) {
            return { entities: data.entities.concat(loadedMainEntities), entitiesDocuments: data.entitiesDocuments };
        }));
    };
    DocumentsSearchComponent.prototype.afterSearchProcessing = function (data) {
        var _a;
        this._searching = false;
        if (data.entitiesDocuments) {
            if (document_search_helper_1.DocumentSearchHelper.isLoadedPartial(data.entitiesDocuments) && this.mustLoadMoreDocuments(data.entitiesDocuments)) {
                if (this._requestsLimit <= 3) {
                    this._requestsLimit++;
                    this.loadMoreDocuments();
                }
                else {
                    this.dialog.open(warning_dialog_component_1.WarningDialogComponent, dialog_config_helper_1.DialogConfigHelper.getWarningDialogConfig('cms_warning', 'cms_documents_search_warning'));
                }
            }
            else {
                (_a = this._mainEntitiesDocuments).push.apply(_a, this.constructViewModel(data.entitiesDocuments.documents, data.entities, this.categoryRelationConfig, this._categoryNameMetaFields, this._languageId));
                this._isLoadedPartial = document_search_helper_1.DocumentSearchHelper.isLoadedPartial(data.entitiesDocuments);
                this._emptyResult = !this._mainEntitiesDocuments.length;
            }
        }
        else {
            this._emptyResult = !this._mainEntitiesDocuments.length;
        }
    };
    DocumentsSearchComponent.prototype.mustLoadMoreDocuments = function (data) {
        return (!this._mainEntitiesDocuments.length && !data.documents.length);
    };
    DocumentsSearchComponent.prototype.onExternalFunctionExecution = function (action, entity, documentId) {
        if (action.externalFunction) {
            action.externalFunction(entity, documentId);
        }
        else if (action.externalFunctionKey && this.externalFunctionExecutorService) {
            this.externalFunctionExecutorService.execute(action.externalFunctionKey, entity, documentId);
        }
    };
    DocumentsSearchComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
    };
    DocumentsSearchComponent.prototype.getFilters = function (entities) {
        var additionalFilters = entities.length ?
            document_search_helper_1.DocumentSearchHelper.fillMainEntityDefinedFilters(entities, this._additionalFilters, this.categoryRelationConfig) :
            this._additionalFilters;
        var filters = document_search_helper_1.DocumentSearchHelper.constructFilters(additionalFilters);
        var documentsFilter = document_search_helper_1.DocumentSearchHelper.constructDocumentsFilter(this.fromDate, this.toDate, this._additionalDocumentMetaDataFilters);
        return { filters: filters, documentsFilter: documentsFilter };
    };
    DocumentsSearchComponent.prototype.getMainEntitiesByFilters = function () {
        if (this._additionalFilters.has(this.categoryRelationConfig.mainCategory)) {
            var mainCategoryFilters = this._additionalFilters.get(this.categoryRelationConfig.mainCategory);
            if (mainCategoryFilters.preDefined || mainCategoryFilters.userDefined) {
                var fb = new idm_de_core_frontend_1.FilterBuilder();
                if (mainCategoryFilters.preDefined) {
                    fb.and(mainCategoryFilters.preDefined);
                }
                if (mainCategoryFilters.userDefined) {
                    fb.and(mainCategoryFilters.userDefined);
                }
                var category = this.categoryRelationConfig.mainCategory;
                return this.portfolioService
                    .loadEntitySearchItems(category, [], this._mainCategoryInstanceFiledName, new idm_de_core_frontend_1.PagingOptions(0, 10000), undefined, fb.buildJson(), [idm_um_permission_client_js_1.CategoryPermissionType.VIEW]).pipe(operators_1.map(function (serviceResponse) {
                    return { filtered: true, entities: (serviceResponse.getData() ? serviceResponse.getData() : []) };
                }));
            }
        }
        return Observable_1.Observable.of({ filtered: false, entities: [] });
    };
    DocumentsSearchComponent.prototype.constructViewModel = function (entitiesDocuments, entities, categoryRelationConfig, categoryNameMetaFields, languageId) {
        // prepare main category sections
        var mainCategoryDocuments = document_search_helper_1.DocumentSearchHelper
            .constructMainCategoryDocuments(entitiesDocuments, categoryRelationConfig.mainCategory, this._mainCategoryInstanceFiledName, categoryNameMetaFields, languageId);
        // fill related categories documents
        document_search_helper_1.DocumentSearchHelper.fillRelatedCategoriesDocuments(mainCategoryDocuments, entitiesDocuments, entities, categoryRelationConfig, categoryNameMetaFields, languageId);
        return Array.from(mainCategoryDocuments.values());
    };
    DocumentsSearchComponent.prototype.resetFilterOptions = function () {
        this._startIndex = 0;
        this._itemsCount = 0;
        this._searching = false;
        this._isLoadedPartial = false;
    };
    Object.defineProperty(DocumentsSearchComponent.prototype, "searchText", {
        get: function () {
            return this._searchText;
        },
        set: function (value) {
            this._searchText = value;
            this.resetFilterOptions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "searching", {
        get: function () {
            return this._searching;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "expanded", {
        get: function () {
            return this._expanded;
        },
        set: function (value) {
            this._expanded = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "mainEntitiesDocuments", {
        get: function () {
            return this._mainEntitiesDocuments;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "categoryDisplayName", {
        get: function () {
            return this._categoryDisplayName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "users", {
        get: function () {
            return this._users;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "fromDate", {
        get: function () {
            return this._fromDate;
        },
        set: function (value) {
            this._fromDate = value;
            this.resetFilterOptions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "toDate", {
        get: function () {
            return this._toDate;
        },
        set: function (value) {
            this._toDate = value;
            this.resetFilterOptions();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "localeInfo", {
        get: function () {
            return this._localeInfo;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "emptyResult", {
        get: function () {
            return this._emptyResult;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "searchTextErrorFlag", {
        get: function () {
            return this._searchTextErrorFlag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "additionalFiltersExistsFlag", {
        get: function () {
            return this._additionalFiltersExistsFlag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "additionalDocumentMetaDataFiltersExistsFlag", {
        get: function () {
            return this._additionalDocumentMetaDataFiltersExistsFlag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "dateRangeErrorFlag", {
        get: function () {
            return this._dateRangeErrorFlag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "isLoadedPartial", {
        get: function () {
            return this._isLoadedPartial;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "isDescendingSort", {
        get: function () {
            return this._isDescendingSort;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "getMainMetaDataConfigs", {
        get: function () {
            return this.additionalDocumentMetaDataFilterConfigs.filter(function (config) { return config.showInMain; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsSearchComponent.prototype, "getNotMainMetaDataConfigs", {
        get: function () {
            return this.additionalDocumentMetaDataFilterConfigs.filter(function (config) { return !config.showInMain; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DocumentsSearchComponent.prototype, "rootCategory", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DocumentsSearchComponent.prototype, "additionalFilterConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DocumentsSearchComponent.prototype, "subEntityFilterConfig", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DocumentsSearchComponent.prototype, "additionalDocumentMetaDataFilterConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", category_relation_config_1.CategoryRelationConfig)
    ], DocumentsSearchComponent.prototype, "categoryRelationConfig", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DocumentsSearchComponent.prototype, "additionalActionConfigs", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DocumentsSearchComponent.prototype, "hasPreviewOption", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], DocumentsSearchComponent.prototype, "hasDownloadOption", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DocumentsSearchComponent.prototype, "sortDocumentFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], DocumentsSearchComponent.prototype, "excludedCategories", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DocumentsSearchComponent.prototype, "minQuerySymbols", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], DocumentsSearchComponent.prototype, "searchDocumentsCount", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], DocumentsSearchComponent.prototype, "entityClick", void 0);
    DocumentsSearchComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-documents-search',
            styles: [require('./documents-search.component.css')],
            template: require('./documents-search.component.html')
        }),
        __param(10, core_1.Optional()),
        __metadata("design:paramtypes", [document_search_service_1.DocumentSearchService,
            document_operations_service_1.DocumentOperationsService,
            idm_kb_service_client_js_1.KbService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_locale_service_client_js_1.LocaleService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            http_1.HttpClient,
            idm_de_service_client_js_1.PortfolioService,
            material_1.MatDialog,
            external_function_executor_service_1.ExternalFunctionExecutorService])
    ], DocumentsSearchComponent);
    return DocumentsSearchComponent;
}());
exports.DocumentsSearchComponent = DocumentsSearchComponent;
//# sourceMappingURL=documents-search.component.js.map